import './HeaderMedia360.css';
import React from 'react';
import { get } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import Image360 from '../atoms/Image360/Image360'; // eslint-disable-line
/* import DarkThemeControl from '../BrightcoveVideosAtoms/DarkThemeControl'; */

var HeaderMedia360 = function HeaderMedia360(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var image = get(fields, 'data.item');
  var imageSrc = get(fields, 'data.item.image.jss.value.src');
  var darkMode = get(sitecoreContext, 'darkMode');
  var actions = get(sitecoreContext, 'actions', {});
  var _actions$changeThemeF = actions.changeThemeFunction,
    changeThemeFunction = _actions$changeThemeF === void 0 ? function () {} : _actions$changeThemeF;
  if (!fields || !imageSrc) {
    console.info('HeaderMedia360 component render skipped. No fields provided');
    if (pageEditing) return /*#__PURE__*/React.createElement("div", null, "[Header Media: please provide data source or item should have headerImage field]");
    return null;
  }
  var renderImage = function renderImage() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Image360, {
      imageSrc: imageSrc
    }));
  };
  return /*#__PURE__*/React.createElement(StyledContainer, null, renderImage());
};
var StyledContainer = function StyledContainer(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "header-media header-media-360 styled-curved-image ".concat(commonStyles)
  }, children);
};
var commonStyles = "c1xky6e5";
export default HeaderMedia360;